import { render, staticRenderFns } from "./ListTask.vue?vue&type=template&id=c8c79c06&scoped=true&"
import script from "./ListTask.vue?vue&type=script&lang=js&"
export * from "./ListTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c79c06",
  null
  
)

export default component.exports